export function usePaymentMethods() {
    const { apiClient } = useShopwareContext();

    // Global state to store payment methods
    const paymentMethods = useState("paymentMethods", () => null);
    const paymentMethodData = ref([]);

    // Function to fetch payment methods
    const fetchPaymentMethods = async () => {
        try {
            // Check if data is already in global state
            if (paymentMethods.value) {
                paymentMethodData.value = paymentMethods.value?.data || [];
                return paymentMethods.value;
            }

            const response = await apiClient.invoke(
                "readPaymentMethods get /get-payment-settings",
                { pathParams: {} }
            );

            if (response?.status === 200) {
                // Store in global state
                paymentMethods.value = response.data;
                paymentMethodData.value = response.data?.data || [];
                return response.data;
            }
            return null;
        } catch (error) {
            console.error("Error fetching payment methods:", error);
            return null;
        }
    };

    return { 
        paymentMethodData,
        fetchPaymentMethods
    };
}
